module.exports = __webpack_public_path__ + "static/media/3DPPA25.5c575319.jpg";